'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { SettledBannerShell } from '@/components/market/settled-banner-shell';
import { Icon } from '@/components/ui/icon';
import { Loading03Icon } from '@/components/ui/icon/glyphs';

/**
 * Resolved (pending-graduation) banner — shown above the market header while a
 * `resolved` market's winning token is being finalised into a tradable AMM
 * token. Uses the brand-emphasized `SettledBannerShell`; the trailing slot is a
 * bordered "Graduating" status pill with an amber spinner.
 */
export function GraduatingBanner(t0) {
  const $ = _c(14);
  const {
    name
  } = t0;
  const t = useTranslations("market.tokenCta");
  let t1;
  if ($[0] !== t) {
    t1 = t("settledTitle");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== name || $[3] !== t) {
    t2 = t("graduatingBody", {
      name
    });
    $[2] = name;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon icon={Loading03Icon} className="size-3.5 shrink-0 animate-spin text-feedback-warning-content motion-reduce:animate-none" aria-hidden="true" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("graduatingStatus");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="flex shrink-0 items-center gap-1.5 rounded-pill border px-2.5 py-1 text-caption font-medium text-foreground-secondary">{t3}{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t5) {
    t6 = <SettledBannerShell tone="brand" title={t1} body={t2} trailing={t5} />;
    $[10] = t1;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}